import { css } from 'styled-components';
import {
  InnerSectionsWrapper,
  OuterSection,
  SectionButton,
} from '../../../../components/Accordion/styles';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { colors, themeSpecificColors } from '../../colors';

export default css`
  ${OuterSection} {
    padding: ${spacing(1)} 0 0 0;
    border-bottom: 1px solid ${colors.neutral04};
    ${mediaQuery.tabletPortrait`
      padding: ${spacing(2)} 0 0 0;
      border-bottom: 1px solid ${colors.neutral04};
  `}
  }

  ${SectionButton} {
    border-radius: 0px;
    margin-top: 0;
    margin-bottom: ${spacing(1)};
    color: ${colors.neutral01};

    ${mediaQuery.tabletPortrait`
      margin-bottom: ${spacing(2)};
    `}
    :hover {
      background-color: ${themeSpecificColors.core01_10};
      outline: solid ${themeSpecificColors.core01_60} 1px;
      outline-offset: -1px;
    }
    :focus-visible {
      border: none;
      background: none;
      box-shadow: 0px 0px 0 4px ${themeSpecificColors.core01_60};
    }
  }

  ${InnerSectionsWrapper} {
    border-top: solid 1px ${colors.neutral04};
    margin-bottom: ${spacing(2)};
    ${mediaQuery.tabletPortrait`
      margin-bottom: ${spacing(3)};
    `}
    & > div {
      padding-top: 0;
      // reset margin of the component wrapper inside accordion section
      margin-bottom: 0;

      // match the top & bottom space around the component wrapper inside accordion section
      margin-top: ${spacing(2)}; // should match the margin-bottom of InnerSectionWrapper
      ${mediaQuery.tabletPortrait`
        margin-top: ${spacing(3)};
      `}
    }
  }
`;
